export default function cleanUUID(uuid: string | undefined): string {
  if (!uuid) {
    return ''
  }
  uuid = uuid.replaceAll('"', '')
  uuid = uuid.replaceAll('/', '')
  uuid = uuid.replaceAll('\\', '')
  return uuid
}
